import { useEffect, useState } from 'react';

export function useSingleVerkstedsInfo(url) {

    const [verksted, setVerksted] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        async function fetchVerkstedInfo() {
            try{
                setIsLoading(true);
                setIsError(false);

                const response = await fetch(url);
                const verkstedInfo = await response.json();

                setVerksted(verkstedInfo);
                console.log(verksted)
            }catch (error) {
                console.log(error);
                setIsError(true);
            } finally {
                setIsLoading(false);
            }
        }

        fetchVerkstedInfo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [url]);

    return {verksted, isLoading, isError};

};

export default useSingleVerkstedsInfo;